var bp = window.matchMedia("(max-width: 600px)");
var serviceSwiper = null;
var subjectSwiper = null;

function initSwiper() {
  if (bp.matches) {
    /* ビューポートが 600px 幅より狭い */
    serviceSwiper = new Swiper(".swiper", {
      direction: "horizontal",
      loopAdditionalSlides: 1,
      slidesPerView: 1,
      spaceBetween: 15,

      // ページネーション
      pagination: {
        el: ".swiper-pagination",
        type: "fraction", // 枚数表示
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      speed: 1000,

      watchSlidesProgress: true,
    });
    subjectSwiper = new Swiper(".subjectswiper", {
      direction: "horizontal",
      loopAdditionalSlides: 1,
      slidesPerView: 1,
      spaceBetween: 15,

      // ページネーション
      pagination: {
        el: ".swiper-pagination",
        type: "fraction", // 枚数表示
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      speed: 1000,

      watchSlidesProgress: true,
    });
  } else {
    if (serviceSwiper) {
      serviceSwiper.destroy();
    }
    if (subjectSwiper) {
      subjectSwiper.destroy();
    }
  }
}

bp.addListener(initSwiper);
initSwiper();

var modalSwiper01 = null;
var modalSwiper02 = null;
var modalSwiper03 = null;
var modalSwiper04 = null;

MicroModal.init({
  openClass: "is-open",
  disableScroll: true,
  onShow: (modal) => {
    (modalSwiper01 = new Swiper(".modalSwiper01", {
      direction: "horizontal",
      loopAdditionalSlides: 1,
      slidesPerView: 1,
      spaceBetween: 15,

      // ページネーション
      pagination: {
        el: ".modal-grid-pagination01",
        type: "fraction", // 枚数表示
      },
      navigation: {
        nextEl: ".swiper01-button-next",
        prevEl: ".swiper01-button-prev",
      },
      // scrollbar: {
      //   el: ".swiper-scrollbar",
      // },

      speed: 1000,

      watchSlidesProgress: true,
    })),
      (modalSwiper02 = new Swiper(".modalSwiper02", {
        direction: "horizontal",
        loopAdditionalSlides: 1,
        slidesPerView: 1,
        spaceBetween: 15,

        // ページネーション
        pagination: {
          el: ".modal-grid-pagination02",
          type: "fraction", // 枚数表示
        },
        navigation: {
          nextEl: ".swiper02-button-next",
          prevEl: ".swiper02-button-prev",
        },
        // scrollbar: {
        //   el: ".swiper-scrollbar",
        // },

        speed: 1000,

        watchSlidesProgress: true,
      })),
      (modalSwiper03 = new Swiper(".modalSwiper03", {
        direction: "horizontal",
        loopAdditionalSlides: 1,
        slidesPerView: 1,
        spaceBetween: 15,

        // ページネーション
        pagination: {
          el: ".modal-grid-pagination03",
          type: "fraction", // 枚数表示
        },
        navigation: {
          nextEl: ".swiper03-button-next",
          prevEl: ".swiper03-button-prev",
        },
        // scrollbar: {
        //   el: ".swiper-scrollbar",
        // },

        speed: 1000,

        watchSlidesProgress: true,
      })),
      (modalSwiper04 = new Swiper(".modalSwiper04", {
        direction: "horizontal",
        loopAdditionalSlides: 1,
        slidesPerView: 1,
        spaceBetween: 15,

        // ページネーション
        pagination: {
          el: ".modal-grid-pagination04",
          type: "fraction", // 枚数表示
        },
        navigation: {
          nextEl: ".swiper04-button-next",
          prevEl: ".swiper04-button-prev",
        },
        // scrollbar: {
        //   el: ".swiper-scrollbar",
        // },

        speed: 1000,

        watchSlidesProgress: true,
      }));
  },
});
